"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nestSet(obj, [first, ...rest], value) {
    var _a;
    return Object.assign(Object.assign({}, obj), { [first]: rest.length
            ? nestSet((_a = obj[first]) !== null && _a !== void 0 ? _a : {}, rest, value)
            : value });
}
exports.default = nestSet;
